import { toast } from 'react-toastify'

import { Button, Flex, Tab, TabList, Text } from '@chakra-ui/react'
import { MdRemoveCircle } from 'react-icons/md'
import { IconContext } from 'react-icons/'
import { AiOutlinePlus } from 'react-icons/ai'

//Slice
import { useConfirmationModalManagement } from '@/stores/ui/confirmationModalSlice'
import { useAddSubSystemModalManagement } from '@/stores/offers/offersSlice'

//Constant
import { newSubSystem } from '@/features/offers/constants'

const OfferSubSystemTabList = ({ subSystems, isDisabled, canEditSubSystem = false, addSubSystem, removeSubSystem }) => {
  const { open: openConfirmationModal } = useConfirmationModalManagement()
  const { open: openAddSubSystemModal } = useAddSubSystemModalManagement()

  const handleAddSubSystem = async () => {
    const { isSubmitted, subSystemType, profitCenterId, subSystemName } = await openAddSubSystemModal()
    if (isSubmitted) {
      addSubSystem({
        ...newSubSystem,
        type: subSystemType,
        profitCenter: { _id: profitCenterId },
        projectName: subSystemName,
      })
    }
  }

  const handleRemoveSubSystem = async (e, index) => {
    e.stopPropagation()

    if (subSystems.length <= 1) {
      toast.info("Can't Remove the only Sub System")
      return
    }
    const { isConfirmed } = await openConfirmationModal({
      title: 'Confirm to remove sub system',
      message: 'Filled Information will be lost',
    })
    if (!isConfirmed) {
      //Stop current action, and don't open approval modal
      return
    }
    removeSubSystem(index)
  }
  return (
    <Flex pt="2" position="sticky" top="185px" zIndex={3} bg="white" justify={'space-between'}>
      <TabList>
        {subSystems.map((subSystem, index) => (
          <Tab
            key={subSystem.id}
            as={Flex}
            color={'black'}
            _hover={{ color: 'teal' }}
            fontWeight={'bold'}
            isDisabled={isDisabled}
          >
            <Flex alignItems="center" gap="3">
              <Text
                onClick={(e) => {
                  e.stopPropagation()
                  //   setTabIndex(8 + index);
                }}
              >
                {`1.${index + 1}: ${subSystem?.projectName}`}
              </Text>
              {index > 0 && canEditSubSystem && (
                <Text color="red.500" _hover={{ color: 'red.300' }} onClick={(e) => handleRemoveSubSystem(e, index)}>
                  <MdRemoveCircle size={'1.2em'} />
                </Text>
              )}
            </Flex>
          </Tab>
        ))}
      </TabList>

      <Button colorScheme="teal" color={'white'} onClick={handleAddSubSystem} isDisabled={!canEditSubSystem}>
        <IconContext.Provider value={{ color: 'white', size: '20px' }}>
          <div>
            <AiOutlinePlus />
          </div>
        </IconContext.Provider>
      </Button>
    </Flex>
  )
}

export default OfferSubSystemTabList
